// Schema describing every editable content field, grouped into sections.
// type: "text" | "textarea" | "image" | "stringlist" | "objectlist" | "navlist" | "toggle" | "icon" | "color"
export const CONTENT_SCHEMA = [
  {
    key: "nav",
    label: "Navigation menu",
    fields: [
      { path: "nav", label: "Menu items", type: "navlist" },
      { path: "blogPage.navLabel", label: "Blog menu label", type: "text" },
    ],
  },
  {
    key: "hero",
    label: "Hero",
    fields: [
      { path: "hero.eyebrow", label: "Eyebrow", type: "text" },
      { path: "hero.line1", label: "Headline line 1", type: "text" },
      { path: "hero.line2", label: "Headline line 2", type: "text" },
      { path: "hero.ctaBook", label: "Primary button label", type: "text" },
      { path: "hero.ctaConsult", label: "Secondary button label", type: "text" },
      { path: "hero.image", label: "Background image", type: "image" },
    ],
  },
  {
    key: "whatif",
    label: 'The "What if…" section',
    fields: [
      { path: "whatif.heading", label: "Heading (before the …)", type: "text" },
      { path: "whatif.items", label: "What-if lines", type: "objectlist", itemFields: [
        { key: "from", label: "Instead of…" },
        { key: "to", label: "You…" },
      ] },
      { path: "whatif.body1", label: "Paragraph 1", type: "textarea" },
      { path: "whatif.body2", label: "Paragraph 2", type: "textarea" },
    ],
  },
  {
    key: "about",
    label: "About Karen",
    fields: [
      { path: "about.eyebrow", label: "Eyebrow", type: "text" },
      { path: "about.headingLead", label: "Heading (plain part)", type: "text" },
      { path: "about.headingAccent", label: "Heading (accent part)", type: "text" },
      { path: "about.post", label: "Credential line (on photo card)", type: "text" },
      { path: "about.paragraphs", label: "Bio paragraphs", type: "stringlist" },
      { path: "about.credentials", label: "Credential badges", type: "stringlist" },
      { path: "about.image", label: "Portrait photo", type: "image" },
    ],
  },
  {
    key: "treatment",
    label: "Treatment Areas",
    fields: [
      { path: "treatment.eyebrow", label: "Eyebrow", type: "text" },
      { path: "treatment.heading", label: "Heading", type: "text" },
      { path: "treatment.intro", label: "Intro paragraph", type: "textarea" },
      { path: "treatment.areas", label: "Treatment areas", type: "treatmentareas" },
      { path: "treatment.spotlightEnabled", label: "Show spotlight note", type: "toggle" },
      { path: "treatment.neuroIcon", label: "Spotlight icon", type: "icon" },
      { path: "treatment.neuroHeading", label: "Spotlight heading", type: "text" },
      { path: "treatment.neuroBody", label: "Spotlight text", type: "textarea" },
      { path: "treatment.ctaLabel", label: "Button label", type: "text" },
      { path: "treatment.ctaNote", label: "Note beside button", type: "text" },
    ],
  },
  {
    key: "consult",
    label: "Free consult band",
    fields: [
      { path: "consult.heading", label: "Heading", type: "text" },
      { path: "consult.body", label: "Body", type: "textarea" },
      { path: "consult.cta", label: "Button label", type: "text" },
      { path: "consult.image", label: "Background image", type: "image" },
    ],
  },
  {
    key: "booking",
    label: "Booking & Fees",
    fields: [
      { path: "booking.eyebrow", label: "Eyebrow", type: "text" },
      { path: "booking.heading", label: "Heading", type: "text" },
      { path: "booking.rate", label: "Rate", type: "text" },
      { path: "booking.session", label: "Session length", type: "text" },
      { path: "booking.note", label: "Note", type: "textarea" },
      { path: "booking.inPerson.title", label: "In-person title", type: "text" },
      { path: "booking.inPerson.when", label: "In-person days", type: "text" },
      { path: "booking.inPerson.where", label: "In-person location", type: "text" },
      { path: "booking.online.title", label: "Online title", type: "text" },
      { path: "booking.online.when", label: "Online days", type: "text" },
      { path: "booking.online.where", label: "Online detail", type: "text" },
      { path: "booking.payments", label: "Payment methods", type: "stringlist" },
      { path: "booking.insurance", label: "Insurance line", type: "textarea" },
      { path: "booking.certification", label: "Certification line", type: "text" },
      { path: "booking.cancellation", label: "Cancellation policy", type: "textarea" },
      { path: "booking.onlineSessions", label: "Online sessions line", type: "text" },
      { path: "booking.hours", label: "Weekly schedule (for search-engine hours)", type: "objectlist", itemFields: [
        { key: "label", label: "Label (e.g., In person, Online)" },
        { key: "days", label: "Days (comma-separated, e.g., Tuesday, Friday)" },
        { key: "opens", label: "Opens (24h, e.g., 09:00)" },
        { key: "closes", label: "Closes (24h, e.g., 17:00)" },
      ] },
      { path: "booking.cardHeading", label: "Booking card heading", type: "text" },
      { path: "booking.cardBody", label: "Booking card body", type: "textarea" },
      { path: "booking.cardCta", label: "Booking card button", type: "text" },
      { path: "booking.image", label: "Booking card image", type: "image" },
    ],
  },
  {
    key: "contact",
    label: "Contact",
    fields: [
      { path: "contact.eyebrow", label: "Eyebrow", type: "text" },
      { path: "contact.heading", label: "Heading", type: "text" },
      { path: "contact.body", label: "Body", type: "textarea" },
      { path: "contact.office.name", label: "Office name (heading above the address)", type: "text" },
      { path: "contact.office.phone", label: "Office phone (optional — hidden if left blank)", type: "text" },
      { path: "contact.office.streetAddress", label: "Address", type: "text" },
      { path: "contact.office.city", label: "City", type: "text" },
      { path: "contact.office.region", label: "State / Province", type: "text" },
      { path: "contact.office.postalCode", label: "Postal / ZIP code", type: "text" },
      { path: "contact.submitLabel", label: "Submit button label", type: "text" },
      { path: "contact.formNote", label: "Form note", type: "text" },
    ],
  },
  {
    key: "footer",
    label: "Footer",
    fields: [
      { path: "footer.taglineLead", label: "Tagline (plain)", type: "text" },
      { path: "footer.taglineAccent", label: "Tagline (accent)", type: "text" },
      { path: "footer.cta", label: "Button label", type: "text" },
      { path: "footer.certLine", label: "Copyright line", type: "text" },
      { path: "footer.madeLine", label: "Made-with line", type: "text" },
    ],
  },
  {
    key: "blogPage",
    label: "Blog page header",
    fields: [
      { path: "blogPage.eyebrow", label: "Eyebrow", type: "text" },
      { path: "blogPage.heading", label: "Heading", type: "text" },
      { path: "blogPage.subtitle", label: "Subtitle", type: "textarea" },
    ],
  },
  {
    key: "links",
    label: "Booking links (Jane App)",
    fields: [
      { path: "links.janeBook", label: "Book a session URL", type: "text" },
      { path: "links.janeConsult", label: "Free consult URL", type: "text" },
    ],
  },
];
